module.exports = __webpack_public_path__ + "static/media/grocery-product-7.836949f1.png";